import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, update } from 'firebase/database';
import { FaTimes, FaUser, FaPhone, FaMapMarkerAlt, FaGraduationCap, FaCalendarAlt, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

const DetailModal = ({ isOpen, onClose, data, title = "अर्जदाराची संपूर्ण माहिती", onStatusUpdate }) => {
    const [status, setStatus] = useState('');
    const [remark, setRemark] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (data) {
            setStatus(data.status || 'pending');
            setRemark(data.remark || '');
        }
    }, [data]);

    if (!isOpen || !data) return null;

    const handleUpdate = async () => {
        if (onStatusUpdate) {
            await onStatusUpdate(data.id, { status, remark });
            onClose();
            return;
        }

        setSaving(true);
        try {
            const tablePath = data.type === 'नवीन' ? 'EngineerLotteryRegistrations' : 'EngineerRegistrations';
            const itemRef = ref(db, `ekamwatapzp/${tablePath}/${data.id}`);
            await update(itemRef, {
                status,
                remark,
                updatedAt: Date.now()
            });
            onClose();
        } catch (error) {
            console.error("Error updating status:", error);
            alert("स्थिती अपडेट करताना त्रुटी आली.");
        }
        setSaving(false);
    };

    const details = [
        { label: "अर्जदाराचे नाव", value: `${data.firstName || ''} ${data.middleName || ''} ${data.surname || ''}`, icon: <FaUser /> },
        { label: "मोबाईल नंबर", value: data.whatsappNo || data.mobileNo || "N/A", icon: <FaPhone /> },
        { label: "तालुका", value: data.taluka || "N/A", icon: <FaMapMarkerAlt /> },
        { label: "पात्रता", value: data.technicalQualification || data.qualification || "N/A", icon: <FaGraduationCap /> },
        { label: "नोंदणी दिनांक", value: data.submittedAt ? new Date(data.submittedAt).toLocaleDateString('mr-IN') : "N/A", icon: <FaCalendarAlt /> },
    ];

    return (
        <div className="fixed inset-0 z-[1000] overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 transition-opacity" aria-hidden="true" onClick={onClose}>
                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4 flex justify-between items-center">
                        <h3 className="text-lg font-bold text-white italic tracking-tight">{title}</h3>
                        <button onClick={onClose} className="text-white hover:text-gray-200 transition-colors">
                            <FaTimes size={20} />
                        </button>
                    </div>

                    <div className="bg-white px-6 pt-6 pb-4">
                        <div className="space-y-4">
                            {details.map((item, index) => (
                                <div key={index} className="flex items-start gap-4 p-3 bg-gray-50 rounded-xl border border-gray-100 hover:border-blue-100 transition-colors">
                                    <div className="mt-1 text-blue-500">{item.icon}</div>
                                    <div>
                                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{item.label}</p>
                                        <p className="text-sm font-bold text-gray-700 mt-0.5">{item.value}</p>
                                    </div>
                                </div>
                            ))}

                            <div className="pt-4 border-t border-gray-100">
                                <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">स्थिती अपडेट करा (Update Status)</label>
                                <select 
                                    className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm font-bold text-gray-700 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all italic"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="pending">प्रलंबित (Pending)</option>
                                    <option value="accepted">मंजूर (Accepted)</option>
                                    <option value="rejected">नाकारले (Rejected)</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">शेरा (Remark)</label>
                                <textarea 
                                    rows="3"
                                    className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm font-bold text-gray-700 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all italic resize-none"
                                    placeholder="तुमचा शेरा प्रविष्ट करा..."
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                ></textarea>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 px-6 py-4 flex gap-3">
                        <button
                            type="button"
                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-xl text-xs font-bold shadow-lg shadow-blue-100 uppercase transition-all transform active:scale-95"
                            onClick={handleUpdate}
                            disabled={saving}
                        >
                            {saving ? "जतन होत आहे..." : "स्थिती जतन करा"}
                        </button>
                        <button
                            type="button"
                            className="flex-1 bg-white border border-gray-200 text-gray-600 px-4 py-3 rounded-xl text-xs font-bold uppercase hover:bg-gray-100 transition-all transform active:scale-95 shadow-sm"
                            onClick={onClose}
                        >
                            बंद करा
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailModal;
